import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { LEGAL_CONTENT } from "../legalContent";

export default function LegalPage({ pageKey }) {
    const doc = LEGAL_CONTENT[pageKey];
    return (
        <main data-testid={`legal-page-${pageKey}`} className="pt-[72px] min-h-screen">
            <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20 sm:py-28">
                <Reveal>
                    <Overline>{doc.overline}</Overline>
                    <h1 className="mt-6 font-serif-display text-4xl sm:text-5xl tracking-tight text-[#FAFAFA]">{doc.title}</h1>
                    <p className="mt-4 text-xs font-mono-accent text-zinc-500">{doc.updated}</p>
                    <p className="mt-8 text-base leading-relaxed text-zinc-400">{doc.intro}</p>
                    <div className="hairline mt-10" />
                </Reveal>

                <div className="mt-12 space-y-10">
                    {doc.sections.map((s, i) => (
                        <Reveal key={s.heading} delay={i * 0.05}>
                            <section>
                                <h2 className="font-serif-display text-2xl tracking-tight text-[#FAFAFA]">
                                    <span className="text-amber-500/60 mr-3 font-light">{String(i + 1).padStart(2, "0")}</span>
                                    {s.heading}
                                </h2>
                                <p className="mt-4 text-sm sm:text-base leading-relaxed text-zinc-400">{s.body}</p>
                            </section>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1} className="mt-16">
                    <Link to="/" data-testid="legal-back-home-link" className="group inline-flex items-center gap-2 text-sm text-amber-400 hover:text-amber-300 transition-colors">
                        <ArrowLeft className="w-4 h-4 transition-transform duration-300 group-hover:-translate-x-1" />
                        Back to LookAura
                    </Link>
                </Reveal>
            </div>
        </main>
    );
}
